import { useCallback, useEffect } from 'react';

import { Page } from '@Components/Page';
import { BPMTable } from '@Components/StickyTable';
import { TableLoading } from '@Components/TableEmptyState';
import { TablePage } from '@Components/TablePage';
import { useSetError } from '@src/redux/modals';

import { HEADERS, PAGE_TITLE } from './streaming-discrepancies-constants';
import { useStreamingDiscrepancies } from './use-streaming-discrepancies';

export const StreamingDiscrepancies = () => {
  const setError = useSetError();
  const { data, isLoading, error } = useStreamingDiscrepancies();

  useEffect(() => {
    if (error) {
      setError({ message: error.message, reportError: error });
    }
  }, [error, setError]);

  const renderTableLoading = useCallback(
    () => <TableLoading isLoading={isLoading} error={error} />,
    [isLoading, error]
  );

  return (
    <Page title={PAGE_TITLE} pageType={PAGE_TITLE} isLoading={isLoading}>
      <TablePage dataTestId='streaming-discrepancies-table' fillHeight>
        <BPMTable headers={HEADERS} data={data ?? []} noRowsRenderer={renderTableLoading} />
      </TablePage>
    </Page>
  );
};
